import dealsHelper from '@/libs/deals';
import perms from '@/libs/permissions';
import { LOANS_WRITE } from '@/libs/permissions_list';

export default {
  computed: {
    isAbleToRequestExtension() {
      return dealsHelper.isDealAbleToRequestExtension(this.loan) &&
        perms.checkPermissions([LOANS_WRITE]);
    },
    isExtensionAllowed() {
      return dealsHelper.isActive(this.loan) && this.isAbleToRequestExtension;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/extension/ExtensionManagerMixin.js